import React from "react";
import Typography from "@material-ui/core/Typography";
import './BasketStyle.css'

const Basket = ({total}) => {
    return <>
        <Typography  className='total'>
            Итого:{total}$
        </Typography>
        </>
}

export default Basket